import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product } from 'src/app/models/product';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProductsService } from './../../../services/products.service';

@Component({
  selector: 'product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.sass'],
})
export class ProductDetailsComponent implements OnInit {
  public product: Product = new Product();


  constructor(
    private readonly route: ActivatedRoute, private readonly productService: ProductsService, private configService: ConfigurationService
  ) {
  }
  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.params.code) {
      this.product = (await this.productService.readProduct({ productCode: this.route.snapshot.params.code, branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code, hasExistence: true }).toPromise()).response;
    }
  }

}
